import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
// import { useParams } from "react-router-dom";
import DeleteContractorType from "./DeleteContractorType";
import EditContractorTypes from "./EditContractorTypes";
import CustomTooltip from "../../../../common/CustomTooltip";

const ContractorTypeActionButton = ({
  id,
  handleDelete,
  fetchContractorTypes,
  limit,
  page,
}) => {
  const [showDelete, setShowDelete] = useState(false);
  const [showAccount, setShowAccount] = useState(false);
  // const params = useParams();
  // const projectId = params?.project_id;

  const toggleDeleteModal = () => {
    setShowDelete(!showDelete);
  };

  const toggleContractorTypeModal = () => {
    setShowAccount(!showAccount);
  };

  return (
    <>
      <span>
        <CustomTooltip message={"Edit"}>
          <span>
            <FontAwesomeIcon
              icon={faEdit}
              size="1x"
              onClick={toggleContractorTypeModal}
              data-toggle="modal"
              data-target="#account"
            />
          </span>
        </CustomTooltip>
        {/* <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
        <FontAwesomeIcon
          onClick={toggleDeleteModal}
          icon={faTrash}
          size="1x"
          data-toggle="modal"
          data-target="#deleteAccount"
        /> */}
      </span>
      {showDelete && (
        <DeleteContractorType
          ContractorTypeId={id}
          toggleDeleteModal={toggleDeleteModal}
          handleDelete={handleDelete}
          showDelete={showDelete}
        />
      )}
      {/* {showDelete && (
        <AccountingDelete
          accountingId={id}
          toggleDeleteModal={toggleDeleteModal}
          handleDelete={handleDelete}
          showDelete={showDelete}
        />
      )} */}
      {showAccount && (
        <EditContractorTypes
          fetchContractorTypes={fetchContractorTypes}
          ContractorTypeId={id}
          toggleContractorTypeModal={toggleContractorTypeModal}
          showAccount={showAccount}
          limit={limit}
          page={page}
        />
      )}
      {/* {showAccount && (
        <EditChartOfAccounting
          accountingId={id}
          projectId={projectId}
          toggleAccountModal={toggleAccountModal}
          fetchContractorTypes={fetchContractorTypes}
          showAccount={showAccount}
          // handleDelete={handleDelete}
        />
      )} */}
    </>
  );
};

export default ContractorTypeActionButton;
